export const UNDO_STATE_PENDING = 'pending';
export const UNDO_STATE_APPROVED = 'approved';
export const UNDO_STATE_REJECTED = 'rejected';

export interface IUndoApprovalOption {
    label: string;
    value: string;
}

export interface IUndoState {
    state: {
        canRequestUndo: boolean;
        description: string;
        options: IUndoApprovalOption[];
        showUndoModal: boolean;
        undoApprovalId: number;
        undoRequestId: number;
        submitting: boolean;
        state: string;
    },
    mutations: {

    },
    actions: {

    },
}

export interface IUndoApprovalResource {
    id: number;
    gameId: number;
    playerId: number;
    undoRequestId: number;
    state: string;
    createdAt: string;
    updatedAt: string;
}

export interface IUndoRequestResource {
    id: number;
    gameId: number;
    playerId: number;
    snapshotId: number;
    state: string;
    createdAt: string;
    updatedAt: string;
}

export interface IUndoRequestResponse {
    description: string;
    options: IUndoApprovalOption[];
    canRequestUndo: boolean;
    playerId: number;
    requiredApprovals: IUndoApprovalResource[];
    state: string;
    undoRequestId: number;
}

export interface IUndoApprovalPayload {
    gameId: number;
    state: string;
    undoApprovalId: number;
}

